// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"Pagination_Pagination__VfJlu","Title":"Pagination_Title__7IgVU","Pages":"Pagination_Pages__5Wj2q","Page":"Pagination_Page__1YTQV","Active":"Pagination_Active__5rHks"};